<template>
  <div class="row no-gutters row-bordered row-border-light">
    <div class="col-md-12 px-2 py-3">
      <div class="border border-dark">
        <div class="p-1" style="height:85vh; background-color: white">
          <l-map v-if="!tst" :zoom="zoom" :center="center" style="z-index: 1000;">
            <l-tile-layer :url="url"></l-tile-layer>
            <l-control></l-control>
            <div class="loader"></div>


          </l-map>
          <l-map v-if="tst" :zoom="zoom" :center="center" style="" ref="myMap">
            <l-tile-layer :url="url"></l-tile-layer>
            
             
            
            <l-control>
              <div class="d-flex flex-column">
                <b-form-select  v-model="selectedCountry" class="mb-3 col-5 ml-auto" @change="ChangeCountry">
                  <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                  </template>

                  <!-- These options will appear after the ones from 'options' prop -->

                  <b-form-select-option v-for="(item,index) in country_list" :key="index+'country'"  :value="item" >{{item}}</b-form-select-option>
                 <!-- <b-form-select-option  :value="'Italy'" >Italy</b-form-select-option>-->
                </b-form-select>
                <b-form-select  v-model="selectedYear" class="mb-3 col-5 ml-auto" @change="ChangeYear">
                  <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Year --</b-form-select-option>
                  </template>
                  <!-- These options will appear after the ones from 'options' prop-->
                  <b-form-select-option v-for="(j,index) in municipality_WNV_years"
                                        :key="index"
                                        :value="j.year" >{{ j.year }}</b-form-select-option>
                </b-form-select>
                <b-form-select v-if="selectedCountry==='Greece'"  v-model="selected" class="mb-3 col-5 ml-auto" @change="ChangeMonth">
                  <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Month --</b-form-select-option>
                  </template>
                  <!-- These options will appear after the ones from 'options' prop-->
                  <b-form-select-option v-for="j in municipality_WNV_months"
                                        :key="j.month"
                                        :value="j.month" >{{ months[j.month-1] }}</b-form-select-option>
                </b-form-select>
                <b-form-select v-else v-model="selected" class="mb-3 col-5 ml-auto" @change="ChangeMonth">
                  <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Month --</b-form-select-option>
                  </template>
                  <!-- These options will appear after the ones from 'options' prop-->
                  <b-form-select-option v-for="j in municipality_WNV_months"
                                        :key="j.month"
                                        :value="j.month" >{{ months[j.month-1] }}</b-form-select-option>
                </b-form-select>
              </div>
               <div class="col-5 p-2 ml-auto info-text" >
                    <p  style= "text-align:justify;font-size:12px;"> Probability of West Nile Virus human cases at province/municipality level, as produced by the MIMESIS dynamic model MIMESIS. </p>
                </div> 
              <div class="col-5 mt-3 ml-auto rounded p-2" style="font: 14px/16px Arial, Helvetica, sans-serif; background: rgba(222, 222, 222, 0.9);">
                <div class="">
                  <div style="display:block">
                    <br>
                    <div style="text-align:center">
                      <strong>Risk Level of WNV transmission to humans</strong>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#bfbfbf"></div>
                        1
                        <br>
                        <div style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#008000"></div>
                        2
                        
                        <div style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#ffff00"></div>
                        3
                        
                        <div style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#FFA500"></div>
                        4
                      
                        <div style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#ff0000"></div>
                        5
                        <br>
                      </div>
                    <br>
                    
                    <div class="d-flex" style="text-align:center">
                      <div class="rounded" style="margin-left:10px; margin-right:2px; height:17px; width:20px; margin-top: 0px; background-color:#ffffff"><i class="fa-solid fa-calendar" style="color:black"></i></div>
                        
                      
                      <strong>Week of the first incidence</strong>
                    </div>
                    <br>
                  </div>
                </div>
              </div>
              
            </l-control>
            
            <l-polygon v-for="(countryData,index) in this.polygon.latlngs"
                       :key="index"
                       :lat-lngs="countryData"
                       :fillColor="colors(municipality_WNV_data[index].pososto1)"
                       :fillOpacity="0.7"
                       :weight="1"
                        @click="test(index)">
              <l-tooltip v-b-tooltip.hover title="Week of incidence for WNV human cases" v-if="municipality_WNV_data[index].week"
                         :options="{ permanent: true, interactive: true }" >
                         <div title="Week of incidence for WNV human cases" class="py-1" >
                        <i class="fa-solid fa-calendar position-fixed" style="font-size:25px;"></i>
                        
                          <div class="position-relative" style="top:5px;left:0;z-index:1001">
                            <p class="text-light px-1" style="font-weight: 500;font-size:13px">{{municipality_WNV_data[index].week}}</p>
                          </div>
                        </div>
              </l-tooltip>
            </l-polygon>

          </l-map>

        </div>
      </div>
    </div>
    <b-modal id="modal-center" v-model="modalError" centered title="Error" hide-footer>
      <p class="my-4">No Data Available</p>
    </b-modal>
  </div>
</template>
<script>
import {LMap, LTileLayer, LCircleMarker, LPolygon,LControl, LMarker,LTooltip} from 'vue2-leaflet';
import axios from '../axios-auth'
import routes from '../routes/routes'
export default {
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LPolygon,
    LControl,
    LMarker,
    LTooltip
  },
  data(){
    return{
      modalError:false,
      polygon: {
        latlngs: []
      },
      tst:false,
      selected:null,
      selectedCountry:null,
      selectedYear:null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      center: [43.6659, 17.1937],
      municipality_WNV_data:'',
      municipality_WNV_months:'',
      municipality_WNV_years:'',
      //months:['May','June','July','August','September','October'],
      months:['January','February','March','April','May','June','July','August','September','October'],
      country_all:{'EL':'Greece','IT':'Italy','RS':'Serbia'},
      country_list:[],
      group:null
    }
  },
  async created(){
    var user =JSON.parse(localStorage.getItem('user'))
    this.group = user.groups
    console.log(this.group)
    for(var rr=0; rr<this.group.length; rr++){
      if(this.group[rr].name==='view_all'){
        this.country_list=['Greece','Italy','Serbia']
      }
      if(this.country_all[this.group[rr].name]){

      
        this.country_list.push(this.country_all[this.group[rr].name])
      }
    }
    this.selectedCountry=this.country_list[0]
    console.log(this.country_list)
    if(this.selectedCountry){
      this.getData()
    }else{
      this.tst=true
      this.modalError=true

    }
    
  },
  methods:{
    async getData(){
      const token = localStorage.getItem('token')
      const municipality_WNV_years_all=await axios.get('humanCasesRisk/west-nile-virus/municipality/years/',{headers: { Authorization: `Bearer ${token}` },
        params:{
            country:this.selectedCountry
          }})////.catch(error=> routes.replace('/'))
      this.municipality_WNV_years=municipality_WNV_years_all.data
      console.log('years',this.municipality_WNV_years)
      
      const municipality_WNV_months_all=await axios.get('humanCasesRisk/west-nile-virus/municipality/months/',{
        headers: { Authorization: `Bearer ${token}` },
        params:{
            year: this.municipality_WNV_years.length >0 ? this.municipality_WNV_years[0].year:null,
            country:this.selectedCountry
          }
          })////.catch(error=> routes.replace('/'))
      this.municipality_WNV_months=municipality_WNV_months_all.data
      console.log('months',this.municipality_WNV_months)

      await this.GetDataMunicipality_WNV(this.municipality_WNV_years[0].year ,this.municipality_WNV_months[0].month, this.selectedCountry)
      this.selectedYear=this.municipality_WNV_years[0].year
      this.selected=this.municipality_WNV_months[0].month
      
    },
    async ChangeCountry(){
      if (this.selectedCountry === 'Italy') {
        this.$refs.myMap.mapObject.fitBounds([[46.2634502432201, 12.0569594997323], [44.6924119881264, 11.1465820717025]])
      } else if (this.selectedCountry === 'Greece') { 
        this.$refs.myMap.mapObject.fitBounds([[40.7634502432201, 23.9569594997323], [35.8924119881264, 23.8465820717025]])
      }else if (this.selectedCountry === 'Serbia') { 
        this.$refs.myMap.mapObject.fitBounds([[47.787197,23.8569594997323],[41.087197,18.6465820717025]])
      }
      this.tst=false
      //await this.GetDataMunicipality_WNV(this.selectedYear ,this.selected, this.selectedCountry)
      this.getData()

    },
    async ChangeMonth(){
      this.tst=false
      await this.GetDataMunicipality_WNV(this.selectedYear ,this.selected, this.selectedCountry)

    },
    async ChangeYear(){
      this.tst=false
      const token = localStorage.getItem('token')
      const municipality_WNV_months_all=await axios.get('humanCasesRisk/west-nile-virus/municipality/months/',{
      headers: { Authorization: `Bearer ${token}` },
      params:{
          year:this.selectedYear,
          country:this.selectedCountry
        }
        })////.catch(error=> routes.replace('/'))
      console.log('months',this.municipality_WNV_months)
      
      this.municipality_WNV_months=municipality_WNV_months_all.data
      this.selected=this.municipality_WNV_months[0].month
      await this.GetDataMunicipality_WNV(this.selectedYear ,this.selected, this.selectedCountry)
    },
    
    colors(pososto1){

      if(pososto1===0){
        return '#bfbfbf'
      }
      if(0< pososto1 && pososto1<= 25){
        return '#008000'
      }
      if(26<= pososto1 && pososto1<= 50 ){
        return '#FFFF00'
      }
      if(51<= pososto1 && pososto1<= 75 ){
        return '#FFA500'
      }
      if(75 < pososto1){
      
        return '#FF0000'
      }
    },
    async GetDataMunicipality_WNV(year, month, country ){
      const token = localStorage.getItem('token')
      console.log('year',year)
      console.log('month',month)
      const municipality_WNV_data_all=await axios.get('humanCasesRisk/west-nile-virus/municipality/',{
        headers: { Authorization: `Bearer ${token}` },
        params:{
          year: year,
          month: month,
          country: country
        }
      })////.catch(error=> routes.replace('/'))
      this.municipality_WNV_data=municipality_WNV_data_all.data
      console.log('data',this.municipality_WNV_data)
      this.polygon.latlngs=[]
      for(var i=0; i<municipality_WNV_data_all.data.length; i++) {
        //var result = country_geom.data[i].geom.split(';')
        //var geojson_pgons = Terraformer.WKT.parse(result[1])
        // console.log(geojson_pgons)

        const latlgn = L.geoJSON(this.municipality_WNV_data[i].json)
        const latlgn_id = latlgn._leaflet_id - 1
        // console.log(latlgn)
        const latlgn_data = latlgn._layers[latlgn_id]._latlngs

        this.polygon.latlngs[i] = latlgn_data
      }
     // console.log(this.polygon)
      this.tst=true
    },
    test(i){
     // console.log(i)
    }

  }

}

</script>

<style>
.custom-select {

    background-color: #00948a!important ;
    color:white
    }
.loader{
  position: relative;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1005;
  background: url('../../public/img/load1.gif') 50% 50% no-repeat rgba(255,193,249,0.5)

}
</style>
